import {create} from "zustand";

export const useEmpresasStore = create((set) => ({
    store: {
        rows: [],
        page: 0,
        rowsPerPage: 10,
        total: 0,
        filter: '',
        sortBy: 'razao_social',
        order: 'asc',
        loading: false,
        error: null,
        ok: null,
        dialogOpen: false,
        confirmId: null,
        editingObject: null,
        empresa: null,
        saving: false,
    },
    dispatch: {
        setRows: (rows) => set((state) => ({store: {...state.store, rows}})),
        setPage: (page) => set((state) => ({store: {...state.store, page}})),
        setRowsPerPage: (rowsPerPage) => set((state) => ({store: {...state.store, rowsPerPage}})),
        setTotal: (total) => set((state) => ({store: {...state.store, total}})),
        setOrder: (order) => set((state) => ({store: {...state.store, order}})),
        setSortBy: (sortBy) => set((state) => ({store: {...state.store, sortBy}})),
        setLoading: (loading) => set((state) => ({store: {...state.store, loading}})),
        setError: (error) => set((state) => ({store: {...state.store, error}})),
        setOk: (ok) => set((state) => ({store: {...state.store, ok}})),
        setSaving: (saving) => set((state) => ({store: {...state.store, saving}})),
        setFilter: (filter) => set((state) => ({store: {...state.store, filter}})),
        setEmpresa: (empresa) => set((state) => ({
            store: {
                ...state.store,
                empresa: typeof empresa === 'function' ? empresa(state.store.empresa) : empresa,
            },
        })),
        setDialogOpen: (dialogOpen) => set((state) => ({store: {...state.store, dialogOpen}})),
        setConfirmId: (confirmId) => set((state) => ({store: {...state.store, confirmId}})),
        setEditingObject: (editingObject) => set((state) => ({store: {...state.store, editingObject}})),
    },
}));

export const useEmpresas = () => {
    const store = useEmpresasStore((state) => state.store);
    const dispatch = useEmpresasStore((state) => state.dispatch);

    return {
        ...store,
        ...dispatch,
    };
};
